module.exports = __webpack_public_path__ + "static/img/tab1.61760a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/tab1.png
// module id = Ej1f
// module chunks = 1